import React from 'react';
import MemberWrapper from './member-wrapper';
import PermissionCapabilities from './permission-capabilities';
import NotificationPreferences from './notification-preferences';
import LogAccessSummary from './log-access-summary';
import MemberGroupList from './member-group-list';
import { noAccessCss, noNotificationCss, glyph } from 'members/helpers';
import { accessLevel, groupAccessLevel, purgeLogsAccess } from 'members/helpers';

class ReadOnlyMember extends React.Component {
  render() {
    return (
      <MemberWrapper
        memberId={this.props.memberId}
        email={this.props.email}
        isCurrentMember={this.props.isCurrentMember}
        isEditAllForm={false}
        showDeleteButton={this.props.showDeleteButton}
        showEditButton={this.props.showEditButton}
        showFormButtons={this.props.showFormButtons}
        onSaveMemberChanges={() => {}}
        onEditMemberCancel={() => {}}
        onEditMemberClick={this.props.onEditMemberClick}
      >
        <div className="grid flex">
          <PermissionCapabilities
            isEditable={false}
            isVisible={!this.props.sso}
            manageMembers={this.props.manageMembers}
            manageBilling={this.props.manageBilling}
            hasLogAccess={this.props.hasLogAccess}
          />

          <NotificationPreferences
            isEditable={false}
            receiveUsageEmails={this.props.receiveUsageEmails}
            receiveBillingEmails={this.props.receiveBillingEmails}
            noNotificationCss={noNotificationCss}
            glyph={glyph}
          />
        </div>

        <LogAccessSummary
          isEditable={false}
          isVisible={this.props.hasLogAccess && !this.props.sso}
          readOnly={this.props.readOnly}
          canAccessAllGroups={this.props.canAccessAllGroups}
          purgeLogs={this.props.purgeLogs}
          accessLevel={accessLevel}
          groupAccessLevel={groupAccessLevel}
          purgeLogsAccess={purgeLogsAccess}
        />

        <MemberGroupList
          isEditable={false}
          isVisible={this.props.hasLogAccess && !this.props.sso}
          memberId={this.props.memberId}
          canAccessAllGroups={this.props.manageMembers || this.props.canAccessAllGroups}
          groups={this.props.groups}
          groupIds={this.props.groupIds}
          glyph={glyph}
        />
      </MemberWrapper>
    );
  }
};

export default ReadOnlyMember;
